module.exports = __webpack_public_path__ + "img/162.44079d58.jpg";